import { render } from "./KRConfidenceActivity.vue?vue&type=template&id=3ba4e966"
import script from "./KRConfidenceActivity.vue?vue&type=script&lang=js"
export * from "./KRConfidenceActivity.vue?vue&type=script&lang=js"
script.render = render

export default script